document.addEventListener('DOMContentLoaded', () => { initCPB(); observeCPB(); });
['cart:updated','cart:item-added','cart:item-removed','change'].forEach(ev => {
  document.addEventListener(ev, () => setTimeout(initCPB, 500));
});
window.addEventListener('resize', () => setTimeout(initCPB, 100));

function observeCPB() {
  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes.forEach(node => {
      if (node.id === 'CartProgressBar' || (node.querySelector && node.querySelector('#CartProgressBar'))) {
        requestAnimationFrame(() => setTimeout(initCPB, 80));
      }
    }));
  }).observe(document.body, { childList: true, subtree: true });
}

function initCPB() {
  document.querySelectorAll('.cart-progress-bar-container').forEach(bar => {
    const count   = parseInt(bar.dataset.shirtCount || '0');
    const goal2   = parseInt(bar.dataset.goal2 || '5');
    const nodesEl = bar.querySelector('.cpb-nodes');
    if (!nodesEl) return;

    nodesEl.querySelectorAll('.cpb-line-svg').forEach(s => s.remove());

    const nodes = Array.from(nodesEl.querySelectorAll('.cpb-node'));
    if (nodes.length < 2) return;

    function cx(node) {
      const c = node.querySelector('.cpb-node__circle');
      const nr = nodesEl.getBoundingClientRect();
      const cr = c.getBoundingClientRect();
      return cr.left + cr.width / 2 - nr.left;
    }
    function cy(node) {
      const c = node.querySelector('.cpb-node__circle');
      const nr = nodesEl.getBoundingClientRect();
      const cr = c.getBoundingClientRect();
      return cr.top + cr.height / 2 - nr.top;
    }

    const x1    = cx(nodes[0]);
    const x2    = cx(nodes[nodes.length - 1]);
    const lineY = cy(nodes[0]);

    let targetX = x1;
    if (count >= goal2) {
      targetX = x2;
    } else if (count >= 1) {
      targetX = cx(nodes[Math.min(count - 1, nodes.length - 1)]);
    }

    const btnColor = getComputedStyle(document.documentElement)
      .getPropertyValue('--color-button').trim() || '63, 114, 255';

    const ns  = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'cpb-line-svg');
    svg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;overflow:visible;';

    const bg = document.createElementNS(ns, 'line');
    bg.setAttribute('x1', x1); bg.setAttribute('y1', lineY);
    bg.setAttribute('x2', x2); bg.setAttribute('y2', lineY);
    bg.setAttribute('stroke', '#e0e0e0');
    bg.setAttribute('stroke-width', '8');
    bg.setAttribute('stroke-linecap', 'round');

    const fill = document.createElementNS(ns, 'line');
    fill.setAttribute('x1', x1);      fill.setAttribute('y1', lineY);
    fill.setAttribute('x2', targetX); fill.setAttribute('y2', lineY);
    fill.setAttribute('stroke', `rgb(${btnColor})`);
    fill.setAttribute('stroke-width', '8');
    fill.setAttribute('stroke-linecap', 'round');

    svg.appendChild(bg);
    svg.appendChild(fill);
    nodesEl.style.position = 'relative';
    nodesEl.insertBefore(svg, nodesEl.firstChild);

    nodes.forEach(node => {
      const goal    = parseInt(node.dataset.goal || '1');
      const reached = count >= goal;
      const was     = node.classList.contains('is-reached');
      if (reached && !was) {
        node.classList.add('is-reached', 'just-reached');
        setTimeout(() => node.classList.remove('just-reached'), 500);
      } else if (!reached) {
        node.classList.remove('is-reached', 'just-reached');
      }
    });
    const start = bar.querySelector('[data-goal="1"]');
    if (start) start.classList.add('is-reached');
  });
}
